<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-title>Make Appointments</ion-title>
        <ion-buttons slot="start">
          <ion-back-button href="/"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-item>
        <ion-label>MM DD YY</ion-label>
        <ion-datetime
          max="2040"
          display-format="DDD, MMM DD, YYYY" 
          picker-format="MMM DD, YYYY"
          :value="appointmentDate"
          ref="theAppointmentDate"
          name="appointmentDate"
          id="appointmentDate"
          placeholder="Select Date"
          @ionChange="onChange($event)"
        ></ion-datetime>
      </ion-item>
      <ion-list v-if="openAppointments.length > 0">
        <ion-item
          text-center
          v-for="openAppointment in openAppointments"
          :key="openAppointment.slotID"
        >
          <ion-label>
            <ion-button
              style="width: 90%"
              size="default"
              class="adjust-font-size"
              expand="block"
              @click="
                makeAppointment(
                  openAppointment.slotID,
                  openAppointment.appointmentDescription
                )
              "
              >{{ openAppointment.appointmentDescription }}</ion-button
            >
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </div>
</template>

<script>
import Repository from "../../repositories/RepositoryFactory";
var AppointmentsRepository = Repository.get("appointments");

export default {
  name: "adminmainpage",
  model: "",
  appointmentDate: "",
  data() {
    return {
      openAppointments: [],
      appointmentDate: "",
    };
  },
  //        <ion-datetime v-bind:value="model" v-bind:ionChange="model = $event.target.value"> </ion-datetime>
  methods: {
    changePassword() {
      let self = this;
      self.$router.push({ name: "change" });
    },

    onChange: async function (event) {
    //this.appointmentDate = this.$refs.theAppointmentDate.value.split("T")[0]
    //alert(this.appointmentDate);
    //this.appointmentDate = event.detail.value.split("T")[0];
    //alert(this.appointmentDate);
    // eslint-disable-next-line no-console
    //console.log(event);
    //var result = await AppointmentsRepository.getUntakenShotAppointments(
    //this.appointmentDate + "~" + this.$store.state.location
    //);

      var result = await AppointmentsRepository.getUntakenShotAppointments(
        event.detail.value.split("T")[0] + "~" + this.$store.state.location
      );


      if (result.data.length < 1) {
        alert("No Appointments Available");
      }

      this.openAppointments = result.data;
    },
    makeAppointment: async function (slotId, appointmentDescription) {
      let self = this;
      // eslint-disable-next-line no-console
      //console.log(event);
      var makeAppointmentParameters = {
        AppointmentDescription: appointmentDescription,
        Location: this.$store.state.location,
        userName: this.$store.state.userName,
        SlotId: slotId,
        UserId: this.$store.state.userId,
      };

      var result = await AppointmentsRepository.createShotAppointment(
        makeAppointmentParameters
      );

      if (result.data.status === "Success") {
        alert("Appointment Created");
        self.$router.push({ name: "main" });
      } else {
        alert("Appointment Not Created");
      }

      //eslint-disable-next-line no-console
      console.log(result.data);
    },
  },
};
</script>
